export default {
  nav: {
    technology: "ODF технология",
    solutions: "Решения",
    partnerships: "Партньорства",
    about: "За нас",
    contact: "Свържете се с нас",
    home: "Начало",
  },
  hero: {
    eyebrow: "ODF РЕШЕНИЯ ОТ НОВО ПОКОЛЕНИЕ",
    headline1: "Иновация,",
    headline2: "въплътена във всеки филм.",
    copy: "NORTIS предоставя авангардни орално разтворими филми (Orally Dissolving Films, ODF) на съвременните уелнес марки и международните пазари, като съчетава удобен формат с надеждна търговска експертиза.",
    cta1: "Открийте ODF технологията",
    cta2: "Станете партньор на NORTIS",
    trust: "Създадено за съвременния начин на живот. Изградено за глобални възможности.",
    scroll: "Превъртете",
  },
  brandline: "Модерна форма на прием. Безусилно преживяване.",
  credibility: {
    title: "По-интелигентен формат за променящия се свят.",
    copy: "Орално разтворимите филми предлагат изискан и удобен начин за прием на внимателно формулирани съставки — без обичайното усещане от таблетки, капсули или течности.",
  },
  whatIsOdf: {
    eyebrow: "ФОРМАТЪТ",
    title: "Какво е ODF?",
    copy: "ODF е ултратънък орален филм, създаден да се разтваря удобно в устата. Компактният му формат предлага модерна алтернатива за марките, които разработват преносими и лесни за употреба уелнес продукти.",
    benefits: [
      { title: "Тънък и преносим", desc: "Ултратънък формат, който пътува без усилие — в джоб, портфейл или чанта." },
      { title: "Употреба без вода", desc: "Създаден за употреба навсякъде и по всяко време, без вода и без подготовка." },
      { title: "Прецизно представяне", desc: "Всеки филм е индивидуално представена единица, опакована за постоянство на качеството." },
      { title: "Създаден за иновации", desc: "Гъвкава основа за модерни продуктови концепции и отличаващи се брандови преживявания." },
    ],
  },
  whyNortis: {
    eyebrow: "ЗАЩО NORTIS",
    title: "Повече от продуктов формат. Цялостна пазарна възможност.",
    copy: "NORTIS е мостът между ODF иновациите и търговските пазари — свързваме обещаващи продукти с партньорите, способни да ги разраснат.",
    points: [
      { title: "Търговска експертиза, фокусирана върху ODF", desc: "Целенасочен фокус върху категорията на орално разтворимите филми и нейната търговска динамика." },
      { title: "Международно снабдяване и пазарно развитие", desc: "Идентифициране на възможности и изграждане на пътища към пазарите в различни региони." },
      { title: "Подкрепа при позициониране на продукт и марка", desc: "Помагаме на партньорите да адаптират ODF концепциите към своите аудитории и канали." },
      { title: "Гъвкави B2B модели на партньорство", desc: "Дистрибуция, собствена марка и пазарно развитие — структурирани според вашите цели." },
      { title: "Подбор с фокус върху качеството", desc: "Дисциплинирана оценка на пригодността, документацията и пазарната готовност." },
      { title: "Дългосрочни отношения", desc: "Партньорства, изградени за устойчив и натрупващ се търговски растеж." },
    ],
  },
  solutions: {
    eyebrow: "ПОРТФОЛИО ОТ РЕШЕНИЯ",
    title: "Портфолио, създадено около съвременния живот.",
    copy: "Разгледайте категориите решения, които NORTIS развива с партньори и пазари по целия свят.",
    viewAll: "Вижте всички решения",
    requestInfo: "Заявете продуктова информация",
    possibilitiesLabel: "Възможности за развитие",
    positioningLabel: "Търговско позициониране",
    availabilityLabel: "Пазарна наличност",
    targetLabel: "Целеви пазар",
    docLabel: "Статус на документацията",
    sheetLabel: "Информационен лист",
    sheetOnRequest: "Наличен при запитване",
    demoBadge: "Демонстрационна концепция",
    filterAll: "Всички",
    pageTitle: "Решения",
    pageSub: "Портфолио с възможност за филтриране на ODF категории решения — структурирано така, че реални продукти да бъдат добавяни с развитието на партньорствата.",
    demoNote: "Представените по-долу елементи са демонстрационни концепции, илюстриращи посоката на всяка категория. Реалните търговски продукти се представят в рамките на активни партньорства.",
  },
  comparison: {
    eyebrow: "ПРЕЖИВЯВАНЕ НА ФОРМАТА",
    title: "Как филмовият формат се сравнява с останалите.",
    copy: "Неутрален поглед върху практическите характеристики на ежедневните формати.",
    note: "Неутрално сравнение единствено на практическите характеристики на форматите. Не представлява твърдение за клинична ефективност или резултатност.",
    formats: ["ODF филм", "Таблетки", "Капсули", "Течности"],
    rows: [
      { label: "Преносимост", values: [2, 2, 2, 0] },
      { label: "Употреба без вода", values: [2, 0, 0, 1] },
      { label: "Индивидуален предварително дозиран формат", values: [2, 2, 2, 0] },
      { label: "Удобство при съхранение", values: [2, 2, 1, 0] },
      { label: "Дискретна употреба в движение", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "МОДЕЛИ НА ПАРТНЬОРСТВО",
    title: "Три начина да градите с NORTIS.",
    cta: "Обсъдете партньорство",
    items: [
      { title: "Дистрибуция", desc: "Занесете избрани ODF продукти на нови територии и в нови търговски мрежи." },
      { title: "Собствена марка", desc: "Разработете отличаващи се ODF концепции под собствената си марка." },
      { title: "Пазарно развитие", desc: "Изградете с NORTIS продуктово позициониране, стратегия за лансиране и дългосрочно пазарно присъствие." },
    ],
  },
  timeline: {
    eyebrow: "КАК ПРОТИЧА СЪТРУДНИЧЕСТВОТО",
    title: "От първия разговор до растежа на пазара.",
    steps: [
      { title: "Откриване на възможности", desc: "Проучваме вашите цели, пазари и подходящите за тях ODF концепции." },
      { title: "Съгласуване на продукт и пазар", desc: "Свързваме правилните продукти с правилния търговски контекст." },
      { title: "Търговска оценка", desc: "Структурираме условия, обеми и реалистична търговска рамка." },
      { title: "Съответствие и подготовка за лансиране", desc: "Преглеждаме документацията и пазарните изисквания преди старта." },
      { title: "Дистрибуция и растеж", desc: "Подкрепяме навлизането, разширяването и дългосрочния растеж на партньорството." },
    ],
  },
  quality: {
    eyebrow: "КАЧЕСТВО И ОТГОВОРНОСТ",
    title: "Качеството започва с правилните въпроси.",
    copy: "В рамките на всяко потенциално партньорство NORTIS оценява пригодността на продукта, документацията, търговската готовност и пазарните изисквания. Наличността на продуктите и регулаторният им статус може да се различават в отделните държави.",
    placeholder: "Проверена документация за качество и сертификати ще бъдат публикувани тук с напредъка на партньорствата.",
  },
  global: {
    eyebrow: "ГЛОБАЛНА ПЕРСПЕКТИВА",
    title: "Създадени за международно сътрудничество",
    copy: "Работим с марки, доставчици, дистрибутори и търговски партньори, за да идентифицираме значими ODF възможности на развиващите се глобални пазари.",
  },
  finalCta: {
    title: "Нека заедно оформим новото поколение на оралния уелнес.",
    copy: "Независимо дали проучвате дистрибуция, собствена марка или нова ODF продуктова концепция — NORTIS е готов да започне разговора.",
    cta: "Започнете разговор",
  },
  footer: {
    desc: "NORTIS свързва иновативни ODF продукти с марки, партньори и пазари по целия свят.",
    nav: "Навигация",
    legal: "Правна информация",
    privacy: "Политика за поверителност",
    terms: "Условия за ползване",
    language: "Език",
    disclaimer: "Наличността, формулировката, класификацията и регулаторният статус на продуктите може да се различават в отделните държави. Информацията на този уебсайт е предназначена за търговски и общи информационни цели и не представлява медицински съвет.",
    rights: "Всички права запазени.",
  },
  tech: {
    eyebrow: "ODF ТЕХНОЛОГИЯ",
    title: "Науката за тънкото.",
    sub: "Образователен преглед на орално разтворимия филм — форматът, преживяването и търговските възможности, които той открива.",
    what: {
      title: "Какво представлява орално разтворимият филм?",
      copy: "Орално разтворимият филм (ODF) е ултратънък лист, създаден да се разтваря удобно в устата. Вместо да поглъща таблетка или да отмерва течност, потребителят просто поставя един филм и го оставя да се разтвори — дискретно, модерно преживяване в забележително компактен формат.",
    },
    structure: {
      title: "Общата структура на филма",
      copy: "Концептуално ODF съчетава структурна основа, носеща матрица със формулираните съставки и сензорен слой, който оформя вкуса и текстурата. Посочете с курсора или докоснете диаграмата, за да разделите концептуалните слоеве.",
      note: "Концептуално изображение, само с илюстративна цел.",
      layers: [
        { title: "Сензорен слой", desc: "Оформя вкуса, текстурата и усещането при разтваряне." },
        { title: "Носеща матрица", desc: "Съдържа внимателно формулираните съставки във филма." },
        { title: "Структурна основа", desc: "Придава на филма неговата цялост, тънкост и стабилност." },
      ],
    },
    experience: {
      title: "Потребителското преживяване",
      copy: "Без вода. Без отмерване. Без прекъсване. Филмът се разтваря дискретно, което прави употребата му естествена при пътуване, работа или в движение. За съвременните потребители самият формат става част от брандовото преживяване.",
    },
    portability: {
      title: "Преносимост и потенциал на опаковката",
      copy: "Индивидуалните филми могат да се представят в тънки сашета, елегантни мултипакети или компактни диспенсъри — формати, подходящи както за модерните търговски рафтове, така и за unboxing моментите при директни продажби.",
    },
    development: {
      title: "Възможности за продуктово развитие",
      copy: "Филмовият формат поддържа широк спектър от продуктови концепции — от ежедневни уелнес рутини до целенасочено лайфстайл позициониране — и дава на марките пространство за отличаване в наситени категории.",
    },
    commercial: {
      title: "Търговски приложения",
      copy: "ODF концепциите се развиват в категориите уелнес, красота отвътре, енергия, сън и функционални съставки — канали, в които удобството и премиум преживяването определят решенията за покупка.",
    },
    regulatory: {
      title: "Пазарни и регулаторни аспекти",
      copy: "Класификацията и изискванията към филмовите продукти се различават според държавата и формулировката. NORTIS подхожда към всеки пазар индивидуално, като преглежда документацията и регулаторния контекст заедно с партньорите преди комерсиализацията.",
    },
    cta: "Заявете техническа информация",
  },
  partnership: {
    eyebrow: "СОБСТВЕНА МАРКА И ДИСТРИБУЦИЯ",
    title: "Два пътя. Един стандарт на партньорство.",
    sub: "NORTIS структурира търговските сътрудничества около два основни модела — и двата създадени за яснота, бързина и дългосрочен растеж.",
    plTitle: "Собствена марка",
    plDesc: "Разработете отличаващи се ODF концепции под собствената си марка, докато NORTIS координира пътя от концепцията до рафта.",
    plSteps: ["Оценка на концепцията", "Избор на продукти", "Координация на бранд и опаковка", "Преглед на документацията", "Подготовка за пазарно лансиране", "Търговско разрастване"],
    distTitle: "Дистрибуция",
    distDesc: "Занесете избрани ODF продукти на вашата територия и във вашата търговска мрежа със структурирана подкрепа на всеки етап.",
    distSteps: ["Оценка на територията", "Съгласуване на портфолиото", "Търговски условия", "Планиране на навлизането на пазара", "Подкрепа при лансиране", "Дългосрочен растеж"],
    formTitle: "Започнете запитване за партньорство",
    formSub: "Разкажете ни за целите си и нашият екип ще ви отговори със следващите стъпки.",
  },
  about: {
    eyebrow: "ЗА NORTIS",
    title: "Фокусирани върху формата, който оформя утрешния ден.",
    copy: "NORTIS беше създаден, за да свързва обещаващите ODF иновации с марките, партньорите и пазарите, способни да ги превърнат в значими търговски продукти. Съчетаваме предприемаческа бързина, международно мислене и дисциплиниран подход към дългосрочните партньорства.",
    positioning: "NORTIS свързва иновативни ODF продукти с марки, партньори и пазари по целия свят.",
    principlesTitle: "Нашите принципи",
    principles: [
      { title: "Прецизност", desc: "Грижа за всеки детайл — от оценката на продукта до комуникацията с партньорите." },
      { title: "Доверие", desc: "Прозрачни очаквания и ангажименти, които възнамеряваме да спазваме." },
      { title: "Прогрес", desc: "Ясна ориентация към развитие и модерни формати." },
      { title: "Партньорство", desc: "Отношения, създадени да се развиват с години, а не с тримесечия." },
      { title: "Глобална перспектива", desc: "Мислене отвъд граници, пазари и потребителски култури." },
    ],
  },
  contact: {
    eyebrow: "КОНТАКТ",
    title: "Нека започнем разговора.",
    sub: "Споделете няколко детайла за вашия интерес и нашият екип ще се свърже с вас.",
    name: "Име и фамилия",
    company: "Компания",
    email: "Служебен имейл",
    country: "Държава",
    website: "Уебсайт",
    interest: "Интерес към партньорство",
    market: "Очакван пазар или територия",
    message: "Съобщение",
    consent: "Давам съгласие NORTIS да съхранява данните ми, за да отговори на това запитване.",
    submit: "Изпратете съобщение",
    sending: "Изпращане…",
    successTitle: "Благодарим — съобщението е получено.",
    successCopy: "Нашият екип ще разгледа запитването ви и ще се свърже с вас скоро.",
    successAnother: "Изпратете ново съобщение",
    errorRequired: "Това поле е задължително.",
    errorEmail: "Моля, въведете валиден служебен имейл.",
    errorConsent: "За да изпратите формуляра, е необходимо вашето съгласие.",
    errorSubmit: "Възникна грешка. Моля, опитайте отново.",
    optional: "По желание",
    interests: {
      distribution: "Дистрибуция",
      privateLabel: "Собствена марка",
      sourcing: "Снабдяване с продукти",
      marketDev: "Пазарно развитие",
      general: "Общо партньорство",
      product: "Продуктова информация",
      technical: "Техническа информация",
    },
    selectPlaceholder: "Изберете опция",
  },
  legal: {
    privacyTitle: "Политика за поверителност",
    termsTitle: "Условия за ползване",
    updated: "Последна актуализация",
    privacy: [
      { h: "1. Общ преглед", p: "Настоящата Политика за поверителност обяснява как NORTIS събира, използва и защитава информацията, подадена чрез този уебсайт. Ангажираме се да обработваме бизнес контактните данни отговорно и прозрачно." },
      { h: "2. Информация, която събираме", p: "Когато изпратите формуляр за контакт или партньорство, ние събираме предоставената от вас информация — като име, компания, служебен имейл, държава, уебсайт, област на интерес и съдържание на съобщението." },
      { h: "3. Как използваме информацията", p: "Подадената информация се използва единствено за отговор на вашето запитване, оценка на потенциално търговско сътрудничество и комуникация с вас по релевантни партньорски въпроси. Не продаваме лични данни." },
      { h: "4. Съхранение и сигурност на данните", p: "Изпратените формуляри се съхраняват сигурно в базата данни на нашето приложение. Достъпът е ограничен до служителите, които се нуждаят от него, за да отговарят на запитвания. Предприемаме разумни технически мерки за защита на съхраняваните данни." },
      { h: "5. Срок на съхранение", p: "Съхраняваме данните от запитванията толкова дълго, колкото е необходимо за управлението на бизнес отношението или колкото изисква приложимото законодателство. Можете да поискате изтриване на данните си, като се свържете с нас." },
      { h: "6. Вашите права", p: "В зависимост от вашата юрисдикция може да имате право на достъп, коригиране или изтриване на личните данни, които съхраняваме за вас. За да упражните тези права, моля, свържете се с нас чрез уебсайта." },
      { h: "7. Промени в тази политика", p: "Възможно е периодично да актуализираме тази Политика за поверителност. Съществените промени ще бъдат отразени на тази страница с актуализирана дата на ревизия." },
    ],
    terms: [
      { h: "1. Приемане на условията", p: "С достъпа до този уебсайт и използването му вие приемате настоящите Условия за ползване. Ако не сте съгласни, моля, преустановете използването на сайта." },
      { h: "2. Информационна цел", p: "Съдържанието на този уебсайт се предоставя единствено за търговски и общи информационни цели. То не представлява медицински, правен или регулаторен съвет и никое съдържание не следва да се тълкува като продуктово твърдение." },
      { h: "3. Наличност на продуктите", p: "Наличността, формулировката, класификацията и регулаторният статус на продуктите може да се различават в отделните държави. Нищо на този уебсайт не представлява предложение за продажба на продукт в конкретна юрисдикция." },
      { h: "4. Интелектуална собственост", p: "Името NORTIS, визуалната идентичност и съдържанието на уебсайта са собственост на NORTIS. Не можете да възпроизвеждате или разпространявате съдържанието на сайта без предварително писмено разрешение." },
      { h: "5. Ограничаване на отговорността", p: "NORTIS полага разумни усилия да поддържа точността на информацията на уебсайта, но не гарантира нейната пълнота. В позволената от закона степен NORTIS не носи отговорност за решения, взети въз основа на съдържанието на уебсайта." },
      { h: "6. Връзки към трети страни", p: "Този уебсайт може да съдържа връзки към ресурси на трети страни. NORTIS не носи отговорност за съдържанието или практиките на външни сайтове." },
      { h: "7. Действие на условията", p: "Настоящите условия може да бъдат периодично актуализирани. Продължаващото използване на уебсайта означава приемане на актуалната версия." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Модерни ODF решения | Партньор за орално разтворими филми", desc: "NORTIS свързва иновативни продукти с орално разтворими филми (ODF) с марки, партньори и пазари по целия свят. Дистрибуция, собствена марка и пазарно развитие." },
    tech: { title: "ODF технология — NORTIS", desc: "Образователен преглед на технологията на орално разтворимите филми: формат, структура, потребителско преживяване и търговски възможности." },
    solutions: { title: "Портфолио от ODF решения — NORTIS", desc: "Разгледайте категориите ODF решения: ежедневен уелнес, енергия, красота, сън, функционални съставки и концепции за собствена марка." },
    partnership: { title: "Собствена марка и дистрибуция — NORTIS", desc: "Станете партньор на NORTIS чрез моделите за дистрибуция, собствена марка или пазарно развитие на ODF продукти." },
    about: { title: "За NORTIS — Фокусирани върху формата на утрешния ден", desc: "NORTIS свързва обещаващи ODF иновации с марките, партньорите и пазарите, способни да ги превърнат в търговски продукти." },
    contact: { title: "Свържете се с NORTIS — Започнете разговор", desc: "Свържете се с екипа на NORTIS, за да обсъдите ODF дистрибуция, собствена марка, снабдяване или пазарно развитие." },
    privacy: { title: "Политика за поверителност — NORTIS", desc: "Как NORTIS събира, използва и защитава информацията, подадена чрез този уебсайт." },
    terms: { title: "Условия за ползване — NORTIS", desc: "Условия, уреждащи използването на уебсайта на NORTIS и неговото информационно съдържание." },
  },
  a11y: {
    mainNav: "Основна навигация",
    mobileNav: "Мобилна навигация",
    homeLink: "Начална страница на NORTIS",
    openMenu: "Отваряне на менюто",
    closeMenu: "Затваряне на менюто",
    langSelector: "Изберете език",
    filmDiagram: "Интерактивна диаграма на слоевете на филма",
    linkedinLabel: "NORTIS в LinkedIn",
    techImageAlt: "Абстрактни наслоени филмови листове",
    yes: "Да",
    partial: "Частично",
    no: "Не",
    filters: "Филтри за решения",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Ежедневен уелнес",
      desc: "Ежедневни филмови концепции, създадени да се впишат естествено в съвременните сутрешни и вечерни рутини.",
      possibilities: ["Продуктови линии, базирани на рутини", "Формати, подходящи за абонамент", "Минималистична премиум опаковка"],
      positioning: "Позиционирани за потребители, търсещи безусилна ежедневна последователност.",
      availability: "В разработка с партньори",
      targetMarket: "Уелнес и лайфстайл търговия",
      docStatus: "Подготвя се според пазара",
    },
    "energy-performance": {
      name: "Енергия и представяне",
      desc: "Концепции за в движение — за потребители, които ценят инерцията: преди тренировка, пътуване или натоварен ден.",
      possibilities: ["Позициониране преди активност", "Компактни мултипак формати", "Смел, модерен брандов език"],
      positioning: "Създадени за бързи, ориентирани към удобството моменти на консумация.",
      availability: "В разработка с партньори",
      targetMarket: "Канали за активен начин на живот и спорт",
      docStatus: "Подготвя се според пазара",
    },
    "beauty-aging": {
      name: "Красота и здравословно стареене",
      desc: "Елегантни филмови концепции за категорията „красота отвътре“, където преживяването и естетиката имат значение.",
      possibilities: ["Премиум бюти позициониране", "Опаковъчни концепции за подарък", "Брандов разказ, воден от ритуала"],
      positioning: "Изискан формат за марки, които издигат ежедневния ритуал за красота.",
      availability: "В разработка с партньори",
      targetMarket: "Красота отвътре и премиум търговия",
      docStatus: "Подготвя се според пазара",
    },
    "sleep-relaxation": {
      name: "Сън и релаксация",
      desc: "Спокойни, вечерно ориентирани концепции, изградени около простотата в края на деня.",
      possibilities: ["Позициониране като вечерен ритуал", "Дискретни формати за нощното шкафче", "Успокояващ сензорен дизайн"],
      positioning: "Създадени за тихия момент преди почивка.",
      availability: "В разработка с партньори",
      targetMarket: "Вечерен уелнес и аптечна търговия",
      docStatus: "Подготвя се според пазара",
    },
    "vitamins-functional": {
      name: "Витамини и функционални съставки",
      desc: "Филмови концепции, изградени около утвърдени функционални съставки, представени в прецизен модерен формат.",
      possibilities: ["Продуктови семейства, водени от съставките", "Ясен и честен дизайн на етикета", "Отличаване чрез формата"],
      positioning: "Съвременна алтернатива в утвърдени категории съставки.",
      availability: "В разработка с партньори",
      targetMarket: "Нутрацевтична и функционална търговия",
      docStatus: "Подготвя се според пазара",
    },
    "custom-private-label": {
      name: "Индивидуални концепции и собствена марка",
      desc: "Бяло платно: индивидуални ODF концепции, разработени под марката на партньора — от идеята до лансирането.",
      possibilities: ["Изцяло индивидуално разработване на концепции", "Координация на бранд и опаковка", "Подкрепа при лансиране и разрастване"],
      positioning: "За партньори, които искат отличаващ се продукт — безспорно техен.",
      availability: "Отворени за запитвания",
      targetMarket: "Собственици на марки и търговци",
      docStatus: "Определя се за всеки проект",
    },
  },
};
